import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Globle } from 'src/assets/globle';
import { Category } from '../../category/category.model';
import { CategoryService } from '../../category/category.service';
import { SubCategory } from '../../subcategory/subCategory.model';
import { SubcategoryService } from '../../subcategory/subcategory.service';
import { Product } from '../product.model';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-productlst',
  templateUrl: './productlst.component.html',
  styleUrls: ['./productlst.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class ProductlstComponent implements OnInit {

  //#region variables
  Categories: Category[] = [];
  subCategories: SubCategory[] = [];
  product: Product = {} as Product
  products: Product[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', 'cardCounts',
    'cardSoldCounts', 'cardNotSoldCounts', 'availableCost', 'imageUrl', "edit", "delete"];
  dataSource!: MatTableDataSource<Product>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  imagPath: any;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  subCategory: SubCategory = {} as SubCategory;
  productStatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  selectedCategory: number = 0;
  selectedSubCategory: number = 0;
  filteredOptionsCategory!: Observable<Category[]>;
  filteredOptionsSubCategory!: Observable<SubCategory[]>;
  searchCategory = new FormControl();
  searchSubCategory = new FormControl();
  language!: number;
  role: string = "";
  directCharge = false;
  pageSize = 100;
  //#endregion

  constructor(private service: ProductService,
    private subCategoryservice: SubcategoryService,
    private categoryService: CategoryService,
    private router: Router,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private storage: SessionStorageService,
    private translate: TranslateService) { }

  ngOnInit() {
    this.productStatus = [{ id: 1, name: "active" }, { id: 0, name: "notActive" }];
    this.selectedStatus = 1;
    this.language = this.localStorage.retrieve("lang");

    this.searchCategory.markAsTouched();
    this.role = this.localStorage.retrieve("userInfo").role;

    var directCharge = this.localStorage.retrieve('directCharge');

    if (directCharge != null && directCharge != undefined) {
      this.directCharge = directCharge
    }
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.getCategory();
    this.fillSearchFromSession();


  }

  fillSearchFromSession() {

    let catg = this.storage.retrieve("catg");
    let subCatg = this.storage.retrieve("subCatg");

    if (catg != null && catg != undefined) {
      this.searchCategory.setValue(catg);
      this.selectedCategory = catg.id;
      this.subCategories = [];
      this.searchSubCategory.setValue('');
      this.getsubCategory();
    }

    if (subCatg != null && subCatg != undefined) {
      this.searchSubCategory.setValue(subCatg);
      this.selectedSubCategory = subCatg.id;
      this.getProduct();
    }
  }

  getCategory() {
    this.localStorage.store('directCharge', this.directCharge);
    this.searchCategory.setValue("");
    this.searchSubCategory.setValue("");
    this.products = [];

    this.dataSource = new MatTableDataSource(this.products);
    this.spinnerOverlay = true;
    this.categoryService.getAll(this.selectedStatus).subscribe(data => {
      this.Categories = data;

      //var userName = this.localStorage.retrieve("userInfo").userName;
      // if (userName == "Noon_Card") {
      //   this.Categories = this.Categories.filter(x => x.id == 1 || x.id == 39 || x.id == 40);
      // }
      this.autoCompleatFilterCategory();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getsubCategory() {
    this.spinnerOverlay = true;
    this.subCategoryservice.getAll(this.selectedCategory, 1, this.directCharge).subscribe(data => {
      this.subCategories = data
      this.autoCompleatFilterSubCategory();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  autoCompleatFilterCategory() {
    this.filteredOptionsCategory = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterCategory(name) : this.Categories.slice())
      );
  }

  autoCompleatFilterSubCategory() {
    this.filteredOptionsSubCategory = this.searchSubCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterSubCategory(name) : this.subCategories.slice())
      );
  }

  _filterCategory(name: string): Category[] {
    const filterValue = name.toLowerCase();
    return this.Categories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  _filterSubCategory(name: string): SubCategory[] {
    const filterValue = name.toLowerCase();
    return this.subCategories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFnCategory(category: Category): string {
    return category && category.arabicName ? category.arabicName : '';
  }

  displayFnSubCategory(subCategory: SubCategory): string {
    return subCategory && subCategory.arabicName ? subCategory.arabicName : '';
  }

  getProduct() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedSubCategory, this.selectedStatus).subscribe(data => {
      this.products = data;
      this.dataSource = new MatTableDataSource(this.products);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/cards/addproducts']);
  }

  edit(id: number) {
    this.router.navigate(['./master/cards/editproduct/' + id]);
  }

  onDelete(id: number) {
    this.product.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.product.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getProduct();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectStatusChange() {
    this.getProduct();
  }

  selectCatChange(value: any) {
    this.selectedCategory = value.id;
    this.subCategories = [];
    this.products = [];
    this.dataSource = new MatTableDataSource(this.products);
    this.searchSubCategory.setValue('');
    this.getsubCategory();
    this.searchSubCategory.markAsTouched();

    this.storage.store('catg', value);
  }

  selectSubCatChange(value: any) {
    this.selectedSubCategory = value.id;
    this.storage.store('subCatg', value);
    this.getProduct();
  }

  getProductCardsCount(row: any, status: number) {
    this.spinnerOverlay = true;
    this.service.getProductCardsCount(row.id, status).subscribe(data => {
      if (status == -1) {
        row.cardCounts = data
      }
      else {
        row.cardSoldCounts = data;
      }

      this.spinnerOverlay = false
    }, error => {
      this.spinnerOverlay = false;
    })
  }
}
